import React from 'react';
import { string } from 'prop-types';
import cardImage from '../../assets/images/postimage.png';
import NamedLink from '../NamedLink/NamedLink';

import { createSlug } from '../../util/urlHelpers';
import {
  convertCardImageURLwebp,
  ensureListing,
  ensureUser,
  getListingCatSubCatRouteParams,
  getValuesFromArray
} from '../../util/data';
import { displayPrice } from '../../util/configHelpers';

import css from './PostCard.module.css';
import { useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { formatMoney } from '../../util/currency';

const priceData = (price, currency, intl) => {
  if (price && price.currency === currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: intl.formatMessage(
        { id: 'ListingCard.unsupportedPrice' },
        { currency: price.currency }
      ),
      priceTitle: intl.formatMessage(
        { id: 'ListingCard.unsupportedPriceTitle' },
        { currency: price.currency }
      ),
    };
  }
  return {};
};

const PriceMaybe = props => {
  const { price, publicData, config, intl } = props;
  const { listingType } = publicData || {};
  const validListingTypes = config.listing.listingTypes;
  const foundListingTypeConfig = validListingTypes.find(conf => conf.listingType === listingType);
  const showPrice = displayPrice(foundListingTypeConfig);
  if ((!showPrice && price) || !price) {
    return null;
  }
  const { formattedPrice } = priceData(price, config.currency, intl);
  return formattedPrice;
};

const PostCard = props => {
  const { listing = {}, config, intl } = props;
  const currentListing = ensureListing(listing);

  const id = currentListing?.id?.uuid || "1111";
  const {
    description = '',
    geolocation = null,
    price = null,
    title = 'draft',
    publicData = {},
    metadata = {},
  } = currentListing.attributes;

  const { cloudListingImages, subCategoryName, categoryName, condition } = publicData;

  const slug = createSlug(title);

  // for getting first Image from cloudnary
  const firstImage = cloudListingImages && typeof cloudListingImages == "object" && Object.keys(cloudListingImages).length ? Object.values(cloudListingImages).map((st) => st)[0] : null;
  const { category, subCategory } = getListingCatSubCatRouteParams(currentListing);

  return (
    <NamedLink name="ListingPage" params={{ id, slug, category, subCategory }} key={id}>
      <div className={css.postCardWrapper}>
        <div className={css.cardImage}>
          <img src={firstImage? convertCardImageURLwebp(firstImage) : ""} alt={"id"} />
        </div>
        <div className={css.cardBody}>
          <div className={css.categoryHeading}>{categoryName} | {subCategoryName}</div>
          <div className={css.cardTitle}>{title}</div>
          <div className={css.cardPrice}>
            {/* <span className={css.discountPrice}>$450</span><span className={css.actualPrice}>USD</span> */}
            <PriceMaybe price={price} publicData={publicData} config={config} intl={intl} />
          </div>

        </div>
        {condition ? <div className={css.condition}>{condition}</div> : null}
      </div>
    </NamedLink>
  );
};



PostCard.defaultProps = {
  className: null,
};

PostCard.propTypes = {
  className: string,
};

export default PostCard;
